import { ErrorMessages, Product, ProductType } from '@inter-ikea-storageone/range';
import { BehaviorParameters } from 'rangeConfig/@types';
import { hideNoFramesInSceneErrorMessage } from 'rangeConfig/shared/rules/hideMenuRules';

const addInterior = ({ coreApi, props, rootState }: BehaviorParameters) => {
  const coreProductId = props.coreProductId || props.coreProductIds[0];

  const interiorProduct = rootState.products.inMarket.find(
    product => product.coreProductId == coreProductId
  );

  const placementResult = coreApi.products.add(coreProductId, props.position);

  if (!placementResult.valid && placementResult.errors && placementResult.errors.length > 0) {
    const determinePlacementAttemptErrorMessage = () => {
      if (!hideNoFramesInSceneErrorMessage(coreApi)) {
        return ErrorMessages.NoFramesInScene;
      } else if (isClothesRail(interiorProduct)) {
        return ErrorMessages.BoaxelClothesRailRequiresShelf;
      } else {
        return ErrorMessages.ItemWontFit;
      }
    };
    const placementAttemptErrorMessage = determinePlacementAttemptErrorMessage();
    if (placementAttemptErrorMessage) {
      coreApi.emit.onPlacementAttempt(placementAttemptErrorMessage);
    }
    coreApi.entities.disposeCollidingEntities(placementResult.errors);
  }
};

const isClothesRail = (product: Product | undefined) =>
  product?.type === ProductType.BOAXEL_CLOTHES_RAIL ||
  product?.type === ProductType.BOAXEL_ADJ_CLOTHES_RAIL;

export default addInterior;
